export default function LinkedInIcon({ currentColor = "white" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_1273_25074)">
        <path
          d="M0 1.844C0 0.8945 0.789 0.125 1.7625 0.125H22.2375C23.211 0.125 24 0.8945 24 1.844V22.406C24 23.3555 23.211 24.125 22.2375 24.125H1.7625C0.789 24.125 0 23.3555 0 22.406V1.844ZM7.4145 20.216V9.3785H3.813V20.216H7.4145ZM5.6145 7.898C6.87 7.898 7.6515 7.067 7.6515 6.026C7.629 4.9625 6.8715 4.154 5.6385 4.154C4.4055 4.154 3.6 4.964 3.6 6.026C3.6 7.067 4.3815 7.898 5.5905 7.898H5.6145ZM12.9765 20.216V14.1635C12.9765 13.8395 13.0005 13.5155 13.0965 13.2845C13.356 12.638 13.9485 11.9675 14.9445 11.9675C16.248 11.9675 16.7685 12.9605 16.7685 14.4185V20.216H20.37V14C20.37 10.67 18.594 9.122 16.224 9.122C14.313 9.122 13.4565 10.172 12.9765 10.9115V10.949H12.9525C12.9605 10.9365 12.9685 10.924 12.9765 10.9115V9.3785H9.3765C9.4215 10.3955 9.3765 20.216 9.3765 20.216H12.9765Z"
          fill={currentColor}
          fillOpacity="0.75"
        />
      </g>
      <defs>
        <clipPath id="clip0_1273_25074">
          <rect
            width="24"
            height="24"
            fill={currentColor}
            transform="translate(0 0.125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
